"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedeemNftRewardResponseToJSON = exports.RedeemNftRewardResponseFromJSONTyped = exports.RedeemNftRewardResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function RedeemNftRewardResponseFromJSON(json) {
    return RedeemNftRewardResponseFromJSONTyped(json, false);
}
exports.RedeemNftRewardResponseFromJSON = RedeemNftRewardResponseFromJSON;
function RedeemNftRewardResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nftPrize': (0, _1.NftRewardPrizeFromJSON)(json['nftPrize']),
        'promoName': !(0, runtime_1.exists)(json, 'promoName') ? undefined : json['promoName'],
        'promoCode': !(0, runtime_1.exists)(json, 'promoCode') ? undefined : json['promoCode'],
        'trackerName': !(0, runtime_1.exists)(json, 'trackerName') ? undefined : json['trackerName'],
    };
}
exports.RedeemNftRewardResponseFromJSONTyped = RedeemNftRewardResponseFromJSONTyped;
function RedeemNftRewardResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nftPrize': (0, _1.NftRewardPrizeToJSON)(value.nftPrize),
        'promoName': value.promoName,
        'promoCode': value.promoCode,
        'trackerName': value.trackerName,
    };
}
exports.RedeemNftRewardResponseToJSON = RedeemNftRewardResponseToJSON;
